import { Landing, LandingServiceCategory } from 'modules/landings-info';
import { ServiceCategory } from 'modules/service-categories';
import { OtherData } from './other-section-types';

/**
 * Возвращает данные для блока "Другие услуги" для категории услуг
 * @param {LandingServiceCategory[] | undefined} serviceCategories
 * @param {ServiceCategory[] | null} serviceCategoryList
 */
export const getServiceCategoryData = (
  serviceCategories: LandingServiceCategory[] | undefined,
  serviceCategoryList: ServiceCategory[] | null
) => {
  if (!serviceCategories) {
    return [];
  }

  return serviceCategories?.reduce((acc, { id, imageSrc }) => {
    const service = serviceCategoryList?.find(({ topCategoryId }) => topCategoryId === id);
    if (!service) {
      return acc;
    }

    return [
      ...acc,
      {
        imageAlt: service.topCategoryName,
        imageSrc,
        title: service.topCategoryName,
        url: service.topCategoryUrl,
      },
    ];
  }, [] as OtherData[]);
};

/**
 * Возвращает данные для блока "Другие услуги" для лендинга
 * @param {string[]} otherSection
 * @param {Landing[] | null} landingList
 */
export const getLandingOtherData = (otherSection: string[], landingList: Landing[] | null) => {
  if (otherSection.length === 0) {
    return [];
  }

  return otherSection.reduce((acc, name) => {
    const landingInfo = landingList?.find(({ landingName }) => landingName === name);
    if (!landingInfo) {
      return acc;
    }

    return [
      ...acc,
      {
        description: landingInfo.description,
        imageAlt: landingInfo.imageAlt,
        imageSrc: landingInfo.imageSrc,
        title: landingInfo.addTitle,
        url: landingInfo.url,
      },
    ];
  }, [] as OtherData[]);
};
